/* eslint-disable react/forbid-prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import { Tabs } from 'shpmtcd'
import OrdersTable from './OrdersTable'
import { initPageView } from '../../Analytics/common'
import '../styles/index.scss'
import OrderStatus from '../containers/OrderStatus'

const { TabPane } = Tabs

export default class Orders extends React.Component {
  componentDidMount() {
    const { fetchOrders } = this.props
    fetchOrders()
    initPageView()
  }

  render() {
    const {
      orders, pagination, fetchOrders, merchantCanonicalName,
      fetchOrderStatus,
    } = this.props
    return (
      <>
        <Tabs>
          <TabPane tab='All Orders' key='all-orders' />
        </Tabs>
        <OrdersTable
          orders={orders}
          pagination={pagination}
          getOrders={fetchOrders}
          getOrderStatus={fetchOrderStatus}
          merchant={merchantCanonicalName}
        />
        <OrderStatus />
      </>
    )
  }
}

Orders.propTypes = {
  fetchOrders: PropTypes.func.isRequired,
  fetchOrderStatus: PropTypes.func.isRequired,
  orders: PropTypes.arrayOf(PropTypes.object).isRequired,
  merchantCanonicalName: PropTypes.string.isRequired,
  pagination: PropTypes.shape({}).isRequired,
}
